import { render, staticRenderFns } from "./honorcategory.vue?vue&type=template&id=7089656b&scoped=true&"
import script from "./honorcategory.vue?vue&type=script&lang=js&"
export * from "./honorcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7089656b",
  null
  
)

export default component.exports